import React from 'react';
import { Accordion, Heading } from '../../components';
import { FormattedMessage, useIntl } from 'react-intl';
import { canShowMarkAsSold, getListingStatusHistory } from '../../util/listing';
import { formatDateIntoPartials } from '../../util/dates';

import css from './SectionContractStatusHistory.module.css';

const SectionContractStatusHistory = props => {
  const { listing, currentUser } = props;

  const intl = useIntl();

  if (!listing) return null;

  const statusHistory = getListingStatusHistory(listing);

  // `canShowMarkAsSold` fulfills the conditions needed for showing statuses;
  // Other users need to see only the first (published) status.
  const statusHistoryFinal = canShowMarkAsSold(currentUser, listing)
    ? statusHistory
    : statusHistory.slice(0, 1);

  const hasHistory = statusHistoryFinal && statusHistoryFinal.length > 0;

  return (
    <div className={css.sectionDetails}>
      <Accordion
        items={[
          {
            title: (
              <Heading as="h2" rootClassName={css.sectionHeading}>
                <FormattedMessage id="General.statusHistory" />
              </Heading>
            ),
            content: '',
          },
        ]}
      >
        {!hasHistory ? (
          <div className={css.statusHistoryEmpty}>
            {intl.formatMessage({ id: 'General.noStatusHistory' })}
          </div>
        ) : (
          <div className={css.statusTimelineWrapper}>
            <div className={css.statusTimeline}>
              {statusHistoryFinal.map(({ at, status }, index) => {
                const isLatest = index === 0;
                const label = intl.formatMessage({ id: `General.${status}` });
                const dateStr = formatDateIntoPartials(new Date(at), intl).dateAndTime;

                return (
                  <div className={`${css.timelineItem} ${isLatest ? css.latest : ''}`} key={at}>
                    <div className={css.timelineDate}>{dateStr}</div>

                    <div className={css.timelinePointWrapper}>
                      <div className={css.timelinePoint} />
                    </div>

                    <div className={css.timelineStatus}>{label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Accordion>
    </div>
  );
};

export default SectionContractStatusHistory;
